import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Filter from './Filter';
import {Wrapper} from './Filters.style';
import {buildOpenStatus} from '../../helpers/data.helper';
import {NON_CATEGORY_FILTER_KEYS} from '../../constants/constants';

export default class Filters extends PureComponent {
  static propTypes = {
    filters: PropTypes.array.isRequired,
    updateSearchParams: PropTypes.func.isRequired,
    appliedFilters: PropTypes.object.isRequired,
    isCategorySearch: PropTypes.bool.isRequired,
    isCurrentSearch: PropTypes.bool,
    closedByDefault: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const {closedByDefault, filters, totalCategoryListCount} = props;
    this.state = {
      openStatus: buildOpenStatus(
        filters,
        closedByDefault,
        totalCategoryListCount
      ),
    };
  }

  componentDidUpdate(prevProps) {
    const {
      isCurrentSearch,
      closedByDefault,
      totalCategoryListCount,
      filters,
      params,
    } = this.props;
    const queryChanged =
      params && prevProps.params && params.q !== prevProps.params.q;
    if (
      queryChanged ||
      (!isCurrentSearch &&
        ((filters && filters !== prevProps.filters) ||
          totalCategoryListCount !== prevProps.totalCategoryListCount))
    ) {
      this.setState({
        openStatus: buildOpenStatus(
          filters,
          closedByDefault,
          totalCategoryListCount
        ),
      });
    }
  }

  toggleStatus = filterName => {
    const {openStatus} = this.state;
    const newOpenStatus = Object.assign({}, openStatus, {
      [filterName]: !openStatus[filterName],
    });
    this.setState({openStatus: newOpenStatus});
  };

  updateSearchParams = updatedParams =>
    this.props.updateSearchParams(updatedParams, true);

  render() {
    const {
      filters,
      appliedFilters,
      showInMobile,
      isCategorySearch,
      closedByDefault,
      params,
    } = this.props;
    // Key describing the currently-applied non-category filters. When it
    // changes, the category list cache must be cleared so the updated
    // (filtered) categories are shown instead of the stale cached set.
    const nonCategoryFilterKey = params
      ? NON_CATEGORY_FILTER_KEYS.map(key => params[key] || '').join('|')
      : '';
    const renderFilters =
      filters &&
      filters.map((filter, index) => (
        <Filter
          filter={filter}
          key={filter.name}
          filterCounts={filter && (filter.data || filter.counts)}
          isRoot={true}
          onFilterChange={this.updateSearchParams}
          isApplied={appliedFilters[filter.name]}
          index={index}
          isCategorySearch={isCategorySearch}
          closedByDefault={closedByDefault}
          openStatus={this.state.openStatus}
          toggleStatus={this.toggleStatus}
          searchQuery={params && params.q}
          nonCategoryFilterKey={nonCategoryFilterKey}
        />
      ));
    return <Wrapper $showInMobile={showInMobile}>{renderFilters}</Wrapper>;
  }
}
